import { useSyncExternalStore } from 'react';

import type { CategoryId } from '@entities/category';

type SettingsDialogState = {
  opened: boolean;
  targetCategoryId: CategoryId | null;
};

let state: SettingsDialogState = { opened: false, targetCategoryId: null };
const listeners = new Set<() => void>();

const publish = (next: SettingsDialogState) => {
  state = next;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => state;

export const useSettingsDialog = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

export const openSettings = () => publish({ opened: true, targetCategoryId: null });

export const openSettingsForCategory = (categoryId: CategoryId) =>
  publish({ opened: true, targetCategoryId: categoryId });

export const closeSettings = () => publish({ opened: false, targetCategoryId: null });
